import { render, staticRenderFns } from "./CycleHeadingSitecore.vue?vue&type=template&id=12771bb8"
import script from "./CycleHeadingSitecore.vue?vue&type=script&lang=js"
export * from "./CycleHeadingSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports